import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class DocConfigServices {
  getDocConfig = async (tenantId, entityName) => {
    let url = `${Constants.DOCUMENT_CONFIGURATION}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (entityName) url += `entity_name=${entityName}&`;
    const logs = await Helpers.get({ url });
    return logs;
  }

  updateDocConfig = async (payload) => {
    const message = await Helpers.post({
      url: Constants.DOCUMENT_CONFIGURATION,
      data: payload,
    });
    return message;
  }
}

export default new DocConfigServices();
